import React, { Component, PropTypes } from 'react';
import './Diglett.scss';

class Diglett extends Component {
  render() {
    return (
      <div className="pokemon">
        <div className="diglett">
          <div className="head">

          </div>
          <div className="body">

          </div>
        </div>
      </div>
    );
  }
}

export default Diglett;



/** WEBPACK FOOTER **
 ** ./source/050-diglett/Diglett.js
 **/